import * as React from "react";
import { CarouselBannerWrap, DotsWrapper, Dot } from "./styles";
import { LinkTargetType } from "../../../services/playground";
import BetterSwiper from "../../components/Swiper";
import ImageView from "../../../components/SmartImage";
const CarouselBanner = (props) => {
    var _a;
    const { elements = [], positionId, placeholderBg, aTarget = LinkTargetType.Blank } = props;
    const [activeIndex, setActiveIndex] = React.useState(0);
    const bannerHeight = ((_a = elements === null || elements === void 0 ? void 0 : elements[0]) === null || _a === void 0 ? void 0 : _a.height) || "auto";
    return (React.createElement(CarouselBannerWrap, { "data-id": positionId, id: positionId },
        React.createElement(BetterSwiper, Object.assign({ isAutoSwipe: true, style: { width: "inherit", height: `${bannerHeight}` } }, (elements.length > 1 ? { onIndexChange: setActiveIndex } : {})), elements.map((item, i) => {
            return (React.createElement("a", Object.assign({ key: i }, (item.link ? { href: item.link, target: aTarget } : {})),
                React.createElement(ImageView, { src: item.img, online: true, key: i, placeholder: placeholderBg, style: {
                        width: "100vw",
                        height: "inherit",
                    } })));
        })),
        React.createElement(DotsWrapper, null, elements.map((_, index) => (React.createElement(Dot, { key: index, active: index === activeIndex }))))));
};
export default CarouselBanner;
